window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.getGradientColor = function (heightValue) {
    if (heightValue >= 3.0) {
        return `rgb(0, 255, 0)`;
    }

    if (heightValue <= -3.0) {
        return `rgb(255, 0, 0)`;
    }

    if (heightValue >= -0.4999 && heightValue <= 0.4999) {
        return `rgb(255, 255, 0)`;
    }

    let red, green, blue = 0;

    if (heightValue > 0.4999) {
        const ratio = (heightValue - 0.5) / (3.0 - 0.5);
        red = Math.round(255 * (1 - ratio));
        green = 255;
    } else {
        const ratio = (Math.abs(heightValue) - 0.5) / (3.0 - 0.5);
        red = 255;
        green = Math.round(255 * (1 - ratio));
    }

    return `rgb(${red}, ${green}, ${blue})`;
};

window.StockCubeCore.calculateLuminance = function (color) {
    const colorObj = new THREE.Color(color);
    return 0.2126 * colorObj.r + 0.7152 * colorObj.g + 0.0722 * colorObj.b;
};
